import { transitionDigitalSavingsQuoteForm } from "../../../actions/digitalSavings/quote";
import { FIELD_STATUS } from "../../../reducers/status";
import { getPersonalDetailsForm } from "../../../selectors/digitalSavings/personalDetails";
import { getQuoteForm } from "../../../selectors/digitalSavings/quote";


export const quoteFormRules = (store, next, action) => {
    const result = next(action);
	const personalDetailsForm = getPersonalDetailsForm(store.getState());
    const quoteForm = getQuoteForm(store.getState());
    const savingCategory = quoteForm.saving_category.value;
    const quoteFormValid = savingCategory === 'monthly' ? validateQuoteFormDetails(quoteForm,personalDetailsForm) : savingCategory === 'once-off' ? validateOnceOffQuoteFormDetails(quoteForm,personalDetailsForm) : validateCombinedQuoteFormDetails(quoteForm,personalDetailsForm);
    const formAction = quoteFormValid
        ? transitionDigitalSavingsQuoteForm.formValid()
        : transitionDigitalSavingsQuoteForm.formInvalid()
    store.dispatch(formAction);
    return result
}

const validateQuoteFormDetails = (formFields,personalDetails) => {
	return (
		personalDetails.firstName &&
		personalDetails.firstName.status === FIELD_STATUS.VALID &&
		personalDetails.surname &&
		personalDetails.surname.status === FIELD_STATUS.VALID &&
		personalDetails.mobileNumber &&
		personalDetails.mobileNumber.status === FIELD_STATUS.VALID &&
        personalDetails.email &&
		personalDetails.email.status === FIELD_STATUS.VALID &&
		formFields.desired &&
		formFields.desired.status === FIELD_STATUS.VALID &&
		formFields.frequency &&
		formFields.frequency.status === FIELD_STATUS.VALID &&
		formFields.startdate &&
		formFields.startdate.status === FIELD_STATUS.VALID &&
        formFields.duration &&
		formFields.duration.status === FIELD_STATUS.VALID 
	);
};

const validateOnceOffQuoteFormDetails = (formFields,personalDetails) => {
	return (
		personalDetails.firstName &&
		personalDetails.firstName.status === FIELD_STATUS.VALID &&
		personalDetails.surname &&
		personalDetails.surname.status === FIELD_STATUS.VALID &&
		personalDetails.mobileNumber &&
		personalDetails.mobileNumber.status === FIELD_STATUS.VALID &&
        personalDetails.email &&
		personalDetails.email.status === FIELD_STATUS.VALID &&
		formFields.lumpsum &&
		formFields.lumpsum.status === FIELD_STATUS.VALID &&
		formFields.startdate &&
		formFields.startdate.status === FIELD_STATUS.VALID &&
        formFields.duration &&
		formFields.duration.status === FIELD_STATUS.VALID
	);
};

const validateCombinedQuoteFormDetails = (formFields,personalDetails) => {
	return (
		personalDetails.firstName &&
		personalDetails.firstName.status === FIELD_STATUS.VALID &&
		personalDetails.surname &&
		personalDetails.surname.status === FIELD_STATUS.VALID &&
		personalDetails.mobileNumber &&
		personalDetails.mobileNumber.status === FIELD_STATUS.VALID &&
        personalDetails.email &&
		personalDetails.email.status === FIELD_STATUS.VALID &&
		formFields.desired &&
		formFields.desired.status === FIELD_STATUS.VALID &&
		formFields.frequency &&
		formFields.frequency.status === FIELD_STATUS.VALID &&
        formFields.lumpsum &&
		formFields.lumpsum.status === FIELD_STATUS.VALID &&
		formFields.startdate &&
		formFields.startdate.status === FIELD_STATUS.VALID &&
        formFields.duration &&
		formFields.duration.status === FIELD_STATUS.VALID
	);
};

